(() => {
  const initHero = (root) => {
    const hero = root.querySelector('[data-wxh-hero]');
    if (!hero || hero.dataset.wxhReady === 'true') return;
    const slides = Array.from(hero.querySelectorAll('[data-wxh-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-wxh-hero-dot]'));
    const prev = hero.querySelector('[data-wxh-hero-prev]');
    const next = hero.querySelector('[data-wxh-hero-next]');
    if (slides.length < 2) { hero.dataset.wxhReady = 'true'; return; }
    let index = 0;
    let timer = null;
    const autoplay = hero.dataset.autoplay === 'true';
    const interval = Math.max(Number(hero.dataset.interval) || 5000, 3000);
    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => { const active = slideIndex === index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); });
      dots.forEach((dot, dotIndex) => { const active = dotIndex === index; dot.classList.toggle('is-active', active); dot.setAttribute('aria-selected', String(active)); });
    };
    const stop = () => { if (timer !== null) { window.clearInterval(timer); timer = null; } };
    const start = () => { stop(); if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; timer = window.setInterval(() => show(index + 1), interval); };
    prev?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.wxhHeroDot) || 0); start(); }));
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start); hero.addEventListener('focusin', stop); hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
    let touchStartX = null;
    hero.addEventListener('touchstart', (event) => { touchStartX = event.touches[0]?.clientX ?? null; }, { passive: true });
    hero.addEventListener('touchend', (event) => { if (touchStartX === null) return; const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX; const distance = touchEndX - touchStartX; if (Math.abs(distance) > 45) { show(index + (distance < 0 ? 1 : -1)); start(); } touchStartX = null; }, { passive: true });
    hero.dataset.wxhReady = 'true'; start();
  };
  const initScrollRows = (root) => {
    root.querySelectorAll('.wxh-product-row-wrap').forEach((wrap) => {
      if (wrap.dataset.wxhReady === 'true') return;
      const row = wrap.querySelector('[data-wxh-scroll-row]'); const prev = wrap.querySelector('[data-wxh-scroll-prev]'); const next = wrap.querySelector('[data-wxh-scroll-next]'); if (!row) return;
      const amount = () => Math.max(row.clientWidth * 0.82, 280);
      prev?.addEventListener('click', () => row.scrollBy({ left: -amount(), behavior: 'smooth' }));
      next?.addEventListener('click', () => row.scrollBy({ left: amount(), behavior: 'smooth' }));
      wrap.dataset.wxhReady = 'true';
    });
  };
  const init = (scope = document) => scope.querySelectorAll('[data-wxh-root]').forEach((root) => { initHero(root); initScrollRows(root); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
